import React from 'react';
import classNames from 'classnames';
import Plan from '../plan';
import Divider from '../../divider';
import ActionButton from '../../action-button';
import PlanRowItem from '../plan-row-item';
import PlanLabel from '../plan-label';
import noop from '../../../../utils/noop';
import { MOBILE_PLAN_PROPTYPES } from './constants';

const defaultCaptions = {};

const PlanMobile = ({
  captions = defaultCaptions,
  highlighted = false,
  disabled = false,
  isLoading = false,
  collapsed = true,
  onPlanSelect = noop,
  onCollapseClick = noop,
  collapseOpenText = '',
  collapseHiddenText = '',
  type = '',
  withExtraPrice = false,
  availabilities,
}) => {
  const { label } = captions;
  const classes = classNames('ws-ui-plan-mobile', {
    'ws-ui-plan-mobile--highlighted': highlighted,
    'ws-ui-plan-mobile--disabled': disabled,
    'ws-ui-plan-mobile--has-label': label,
  });

  const handleCollapseClick = () => {
    onCollapseClick(type);
  };

  return (
    <div className={classes}>
      <PlanLabel highlighted={highlighted} label={label} />
      <Plan
        captions={captions}
        isLoading={isLoading}
        disabled={disabled}
        type={type}
        onPlanSelect={onPlanSelect}
        highlighted={highlighted}
        isCompact
        withExtraPrice={withExtraPrice}
      />
      <div className="ws-ui-plan-mobile__body">
        {!collapsed &&
          availabilities.map(({ text, ...rest }) => (
            <PlanRowItem isCompact key={text} text={text} {...rest} />
          ))}
        <div className="ws-ui-plan-mobile__divider">
          <Divider />
        </div>
        <ActionButton
          label={collapsed ? collapseHiddenText : collapseOpenText}
          iconPlacement="after"
          format="text"
          iconGlyph={collapsed ? 'down' : 'up'}
          onClick={handleCollapseClick}
          fullWidth
        />
      </div>
    </div>
  );
};

PlanMobile.propTypes = MOBILE_PLAN_PROPTYPES;

export default PlanMobile;
